/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeStorefrontLogin} from '../api'

export const useMutationCompleteStorefrontLogin = createReactQueryMutationHook('completeStorefrontLogin', completeStorefrontLogin)
